<template>
  <div>
    <el-top-nav-menu-3
      :logo="logoBase"
      :appTitle="$t('subcontractor.menuTitle1')"
      :dashboard="baseUrl"
      :Menu4Href="true"
      width="1180px"
      :subMenu="[]"
      ref="topNavMenu"
    >
    </el-top-nav-menu-3>
    <div class="registerBox">
      <h1>
        <i
          style="
            color: green;
            font-weight: 600;
            font-size: 50px;
            position: relative;
            top: 5px;
          "
          class="el-icon-check"
        ></i
        >{{ $t('subcontractor.subconSubmitSuccess.messageOne') }}
        <span style="color: #FF142F; cursor: pointer;" @click="goLogin">{{ $t('subcontractor.subconSubmitSuccess.messageTwo') }}</span>
        {{ $t('subcontractor.subconSubmitSuccess.messageThree') }}
      </h1>
      <div class="messageFour">{{ $t('subcontractor.subconSubmitSuccess.messageFour') }}</div>
    </div>
  </div>
</template>

<script>
import logoBase from "../../../assets/images/zjLogo.png";
export default {
  components: {
    logoBase,
  },
  data() {
    return {
      logoBase,
      baseUrl: this.$addUrlPerFix(process.env.VUE_APP_SHOPPAGE_URL),
    };
  },
  methods: {
    goLogin() {
      window.location.href = this.$addUrlPerFix("mla.iccec.cn/login");
    }
  }
};
</script>

<style lang="scss">
.registerBox {
  padding: 100px 0px !important;
  margin-top: 30px !important;
  width: 1184px !important;
  display: flex;
  flex-direction: column;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
  .steps {
    height: 100px;
    width: 55%;
  }
  width: 100%;
  margin: 0 auto;
  padding: 40px 0;
  //   margin: 0 128px !important;
  background: #ffffff;
  border-radius: 2px;
  line-height: 22px;
  .el-steps .el-step {
    .el-step__head.is-success,
    .el-step__main el-step__title is-success {
      color: #ff152e;
      border-color: #ff152e;
    }
    .el-step__icon {
      width: 32px;
      height: 32px;
      .el-step__icon-inner {
        font-size: 20px;
      }
    }
    .el-step__title,
    .el-step__title.is-success {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ff152e;
    }
    .el-step__title {
      color: rgba(0, 0, 0, 0.45);
    }
    .el-step__title is-success,
    .el-step__title is-process {
      color: #ff152e;
    }
    .el-step__line {
      width: 70%;
      margin: 0 15%;
      background: rgba(0, 0, 0, 0.15);
    }
    .el-step__title.is-success {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff152e;
    }
  }
  .currentStep {
    .el-step__head .el-step__icon {
      background: #ff152e;
      border: none;
      color: white;
      font-size: 16px;
    }
  }
}
.main {
  width: 100%;
}
.logo-container {
  width: 330px !important;
}

// 新增样式：优化 h1 文本换行与布局
h1 {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  margin-bottom: 10px;
  line-height: 1.5;
}

.messageFour {
  margin-top: 20px;
  color: rgb(255,190,1);
  font-size: 20px;
  text-align: center;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
